var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReseauFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 501,
    height: 444,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.51 86.139c0 1.576-1.331 2.758-2.958 2.66-1.676-.1-2.957-1.478-2.957-3.054 0-1.576 1.33-2.758 2.957-2.66 1.676.1 2.957 1.478 2.957 3.054Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M316.607 97.071 44.683 73.883c-2.902-.25-5.254 2.454-5.254 6.11v263.428c0 3.606 2.352 6.361 5.254 6.211l270.748-19.692c2.102-.151 4.929-.141 4.929-3.146V102.93c0-3.055-1.702-5.709-3.804-5.859h.051Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M44.407 78.791v264.43c0 3.722 2.31 6.565 5.16 6.41l267.057-17.628c2.064-.156 3.736-2.844 3.736-5.946V101.383L44.358 78.792h.049Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M281.128 188.075c-7.541 13.936-16.856 26.592-26.023 39.543-10.4 14.675 10.399 4.629 13.356 13.05 1.134 3.25.641 6.845.148 10.292l-2.908 19.206c-.394 2.56-.788 5.22 0 7.682 1.923 6.451 8.034 3.398 12.174 6.451 2.316 1.724 2.563 5.22 1.331 7.83-5.619 11.917-23.115 18.861-35.141 13.838-6.013-2.512-11.829-6.057-18.335-6.451-5.224-.296-10.498 1.575-14.342 5.121-5.766 5.318-4.534 18.467-12.519 20.781-2.168.64-4.485.345-6.703-.246-9.413-2.462-15.18-9.947-25.135-10.391-5.57-.246-11.139.493-16.758.345-5.569-.148-11.385-1.379-15.673-4.974-9.906-8.42-1.528-18.319 1.085-27.626 1.133-3.939 1.183-9.012 1.38-13.148.443-10.539-1.331-21.126-5.028-30.975-3.45-9.258-8.575-17.925-15.032-25.46-7.738-9.011-14.194-9.258-24.939-12.902-6.407-2.166-14.44-6.943-12.913-14.921 1.43-7.485 8.773-8.618 15.131-8.716 6.802-.099 13.603.492 20.257 1.871 5.421 1.084 11.582 3.398 15.624-2.117 2.365-3.201-8.921-27.38 3.252-21.668 2.415 1.133 3.993 3.447 6.013 5.171 3.549 2.954 8.625 3.989 13.012 2.61 6.949-2.167 8.921-9.849 14.687-13.789 3.697-2.511 7.886-3.545 10.252-7.781 2.02-3.594 2.809-7.682 3.844-11.671 7.689-29.35 34.944 5.811 46.28 14.331 10.695 8.027 24.051 16.053 37.26 18.663 7.344 1.429 21.291 2.413 20.897 12.804-.148 3.989-2.119 8.667-4.583 13.247h.049Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 208,
    height: 209,
    x: 78,
    y: 117,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M281.128 188.075c-7.541 13.936-16.856 26.592-26.023 39.543-10.4 14.675 10.399 4.629 13.356 13.05 1.134 3.25.641 6.845.148 10.292l-2.908 19.206c-.394 2.56-.788 5.22 0 7.682 1.923 6.451 8.034 3.398 12.174 6.451 2.316 1.724 2.563 5.22 1.331 7.83-5.619 11.917-23.115 18.861-35.141 13.838-6.013-2.512-11.829-6.057-18.335-6.451-5.224-.296-10.498 1.575-14.342 5.121-5.766 5.318-4.534 18.467-12.519 20.781-2.168.64-4.485.345-6.703-.246-9.413-2.462-15.18-9.947-25.135-10.391-5.57-.246-11.139.493-16.758.345-5.569-.148-11.385-1.379-15.673-4.974-9.906-8.42-1.528-18.319 1.085-27.626 1.133-3.939 1.183-9.012 1.38-13.148.443-10.539-1.331-21.126-5.028-30.975-3.45-9.258-8.575-17.925-15.032-25.46-7.738-9.011-14.194-9.258-24.939-12.902-6.407-2.166-14.44-6.943-12.913-14.921 1.43-7.485 8.773-8.618 15.131-8.716 6.802-.099 13.603.492 20.257 1.871 5.421 1.084 11.582 3.398 15.624-2.117 2.365-3.201-8.921-27.38 3.252-21.668 2.415 1.133 3.993 3.447 6.013 5.171 3.549 2.954 8.625 3.989 13.012 2.61 6.949-2.167 8.921-9.849 14.687-13.789 3.697-2.511 7.886-3.545 10.252-7.781 2.02-3.594 2.809-7.682 3.844-11.671 7.689-29.35 34.944 5.811 46.28 14.331 10.695 8.027 24.051 16.053 37.26 18.663 7.344 1.429 21.291 2.413 20.897 12.804-.148 3.989-2.119 8.667-4.583 13.247h.049Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M288.669 109.628H78.513v220.961h210.156V109.628Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M67.128 165.373c-3.352.099-6.605-.738-9.414-2.413-8.576-5.121-21.292-13.64-32.726-24.77-14.44-14.133-22.77-28.463-24.594-42.547v-.197L0 35.318c0-11.917 7.738-21.57 22.327-27.922C34.352 2.176 50.32-.434 67.127.06 83.787.552 99.213 4 110.598 9.712c13.554 6.796 20.651 16.35 20.651 27.675l-.345 57.469v.197c-1.676 13.493-9.365 27.429-22.918 41.562-10.843 11.327-23.115 20.289-31.543 25.854-2.81 1.822-6.013 2.856-9.365 2.955l.05-.05Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M70.48 165.373c-3.303.099-6.507-.738-9.267-2.413-8.477-5.121-20.995-13.64-32.282-24.77-14.293-14.133-22.524-28.463-24.298-42.547v-.197L4.24 35.318c-.05-11.917 7.64-21.57 21.981-27.922C38.098 2.176 53.82-.434 70.48.06c16.41.49 31.64 3.939 42.877 9.65 13.357 6.796 20.405 16.35 20.405 27.675l-.296 57.469v.197c-1.676 13.493-9.217 27.429-22.573 41.562-10.695 11.327-22.82 20.289-31.149 25.854-2.76 1.822-5.964 2.856-9.216 2.955l-.05-.05Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m8.182 35.318.345 59.832c3.943 30.532 39.823 55.253 55.496 64.609 4.485 2.709 10.202 2.512 14.638-.394 15.328-10.046 49.237-35.407 52.884-64.757l.345-57.271C131.84-5.161 8.182-9.052 8.182 35.317Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M71.366 150.551c-.296 0-.739 0-1.183-.296-6.456-3.89-18.926-12.065-29.768-22.702-11.73-11.523-18.483-22.701-20.06-33.19l-.345-58.848c0-5.663 4.485-10.49 13.258-14.33 9.808-4.334 23.707-6.599 38.049-6.254 14.244.345 27.748 3.2 37.063 7.83 8.28 4.087 12.469 8.913 12.469 14.38l-.295 56.778c-1.43 10.194-7.787 21.126-18.926 32.649C91.13 137.402 78.907 146.02 72.5 150.157a2.06 2.06 0 0 1-1.134.344v.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M69.888 146.512c-6.506-3.989-18.088-11.72-28.143-21.667-11.04-10.834-17.398-21.225-18.876-30.877l-.345-58.503c0-4.038 3.745-7.731 10.99-10.981 9.266-4.088 22.574-6.254 36.374-5.959 13.701.296 26.614 3.004 35.486 7.387 6.9 3.398 10.399 7.14 10.399 11.08l-.296 56.582c-1.429 9.357-7.442 19.55-17.94 30.384-9.758 10.095-21.144 18.171-27.6 22.456l-.05.098Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.895 102.586c-2.07 0-3.942-.985-4.977-2.61L44.751 74.861c-1.38-2.166-.641-5.318 1.725-7.14 2.415-1.822 5.618-1.576 7.146.69L65.5 85.843l17.743-33.388c1.725-3.25 5.964-5.27 9.512-4.481 3.647.788 5.126 4.235 3.253 7.633L71.366 99.533c-1.035 1.822-3.006 3.004-5.224 3.053h-.247Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDBBA",
    d: "m286.697 44.035 2.859-5.368s2.612-.542 3.795-2.413l1.183-1.822s.591-1.97-1.528-4.087c-.493-.493-.69-1.133-.641-1.822.296-2.02.887-6.156 1.035-7.24.049-.689-.246-1.526-.542-2.215a.557.557 0 0 0-1.035.049l-2.267 8.371s-1.824-.492-2.415 1.084c0 0-1.627.936-1.824 2.61-.246 1.674 0 5.564 0 5.564l-2.513 5.664 3.943 1.674-.05-.05Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M290.443 43.197c-1.528 3.644-10.301 24.721-.246 44.271 11.188 21.816 41.4 33.191 71.514 23.392.246 3.939 2.71 53.233-21.538 65.052-26.023 12.656-75.112-21.816-83.047-65.052-6.851-37.032 19.566-66.973 23.854-71.651l9.463 3.988Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M386.551 435.973c1.035.935 1.133 3.2 1.133 4.629v1.181c-.64 1.675-3.844 1.626-8.97 1.823-8.083.344-10.547.837-11.04-.394-.542-1.133 1.035-2.906 1.183-3.103.937-1.034 2.021-1.379 4.091-1.92 3.844-1.035 6.506-1.527 7.245-1.724 4.929-1.034 5.766-1.182 6.407-.542h-.049v.05Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDBBA",
    d: "m380.883 427.946-.296 9.209c.246.394 3.056 1.625 5.175.345l1.627-9.111-6.408-.492h-.049l-.049.049Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M318.437 434.742c1.38 1.379 1.824 4.038.789 5.417-1.035 1.379-2.809.492-7.541.886-5.126.394-6.358 1.724-9.906.936-1.43-.296-3.993-1.133-3.993-2.118 0-.689 1.233-1.132 5.422-2.807 5.865-2.314 5.816-2.413 7.146-2.708 3.155-.69 6.358-1.428 8.182.394h-.099Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDBBA",
    d: "m314.741 426.518-2.119 8.667c.246.493 2.908 1.822 5.125.788l3.401-8.519-6.358-.936h-.049Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M327.555 238.305a791.73 791.73 0 0 1-1.922 96.421c-2.809 34.865-7.59 66.529-13.258 94.451 3.352.689 6.654 1.428 10.005 2.118 7.886-8.175 17.743-20.979 21.883-38.461 2.563-10.883 1.233-16.3 2.514-29.596 2.07-21.126 7.886-32.452 13.603-49.688 5.175-15.512 10.991-38.164 13.209-68.154-15.328-2.364-30.706-4.777-46.083-7.141h.049v.05Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M332.139 372.546c3.696-14.478 10.695-18.319 10.942-32.009.197-9.702-3.352-10.44-3.105-19.747.345-14.035 8.575-21.373 12.715-30.237 4.337-9.307 6.063-24.277-5.717-49.244 8.872 1.378 17.743 2.708 26.565 4.087-2.218 29.99-8.083 52.642-13.208 68.155-5.767 17.235-11.583 28.561-13.603 49.687-1.331 13.247 0 18.713-2.514 29.596-4.14 17.532-13.997 30.237-21.883 38.461-.838-.197-1.676-.345-2.563-.542 8.576-10.145 11.533-19.304 12.322-26.691 1.232-12.015-3.697-16.94 0-31.566l.049.05Z",
    opacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M360.823 236.483c3.992 36.441 7.59 73.473 10.893 111.293 2.415 28.316 4.632 56.336 6.604 84.011 3.401.246 6.703.493 10.103.69a116.713 116.713 0 0 0 9.02-27.577c2.809-14.478 1.528-22.998 2.316-37.919.887-16.743 3.204-20.486 6.654-41.759 6.9-43.139 10.35-64.708-.592-77.413-3.548-4.087-14.588-14.379-44.948-11.277h-.05v-.049Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M261.413 70.774c.198 4.432 1.085 8.126 2.268 11.179 4.386 10.932 14.933 18.91 12.715 31.123-1.084 6.106-4.435 8.273-3.105 12.705 1.972 6.303 9.907 6.008 18.433 13.148 7.541 6.353 7.985 12.164 11.829 17.531 5.224 7.239 17.102 13.838 45.885 11.77-2.562 3.25-5.667 5.958-9.315 7.731-26.023 12.656-75.112-21.815-83.047-65.052-2.71-14.921-.098-28.611 4.288-40.085h.049v-.05Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M313.312 190.242c1.133 16.3 2.267 16.497 4.879 39.445 2.514 21.963 2.908 34.422 4.387 41.908.985 5.22 2.563 7.977 5.668 9.799 4.879 2.906 6.653-.591 31.641-3.102 16.757-1.674 25.284-2.413 33.761.394 8.724 2.955 13.061 7.436 16.757 8.519.838.246 1.676.296 2.514.099.296-.05.641-.197.936-.296 4.584-2.019 5.176-9.898 5.718-23.637.838-21.225.788-35.604.887-40.775.296-18.368 3.943-33.339 9.167-49.885 1.479-4.826 3.154-9.75 4.879-14.921 4.83-14.478 9.858-26.198 13.751-34.422-18.186-6.156-46.033-13.001-79.991-11.572-19.665.837-36.62 4.235-50.026 7.977-1.774 10.145-3.647 20.24-5.47 30.433a369.756 369.756 0 0 0 .591 40.184v-.098l-.049-.05Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDBBA",
    d: "M370.385 88.306c.296 5.958 1.183 10.636 1.971 13.837.888 3.694 1.479 4.58 2.218 5.368 1.085 1.133 2.613 2.019 11.238 3.693 4.682.887 5.273.838 5.421 1.33.591 2.216-11.631 10.538-24.791 9.406-8.083-.69-15.574-4.875-15.279-7.288.296-2.413 8.379-1.527 10.548-6.058 1.478-3.151-.592-7.288-2.957-10.735 1.922-4.087 9.758-5.27 11.631-9.406h.049l-.049-.147Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M354.268 82.446c-3.203-3.792-3.746-10.637-.542-15.217 2.711-3.94 7.393-4.678 10.104-5.17 7.984-1.38 18.334 1.477 22.228 8.666 2.316 4.285-1.725 13.592-2.317 15.266-.69 1.92-2.119 2.61-3.4 4.088-1.775 2.019-4.535 5.269-8.97 10.686-.493-1.478-1.134-3.398-2.12-5.368-.345-.788-1.971-3.743-4.14-6.156-4.436-4.875-7.787-3.25-10.843-6.844v.049Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDBBA",
    d: "M377.926 96.086s-4.83 8.963-15.378 8.864c-9.462-.098-11.927-21.126-6.16-25.952 1.922-1.625 5.963-2.413 9.216-1.724 1.972.394 2.662 1.182 5.865 1.823 2.957.59 3.795.246 4.682.935 1.134.887 2.07 3.103.592 9.406 1.725-1.92 3.795-2.709 5.421-2.068.247.098.887.541 1.331 1.132 1.429 2.315-.591 5.516-5.52 7.584h-.049Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M376.496 78.752c-.394.345 1.085 1.97 1.233 4.383.492 4.629-3.993 10.44-8.724 11.227-2.859.395-3.696-1.23-8.428-1.477-2.908-.197-5.372.345-6.851.788-1.183 5.17.493 10.243 3.992 12.361 3.796 2.314 8.428.541 10.351-.197 1.33-.493 5.421-2.069 7.442-6.058 2.07-4.136-.296-6.401 2.218-9.307 1.232-1.428 2.957-2.117 4.534-4.875.394-.788.69-1.428.838-1.822-2.563-2.413-5.964-5.466-6.605-4.925h.05l-.05-.098Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M357.275 95.299s2.07.935 5.569.59c.197 0 .345 0 .394.1.099.344-2.07 1.969-4.14 1.476-1.478-.344-2.71-1.674-2.563-2.019.05-.197.395-.197.69-.098l.05-.05Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M322.43 271.545c1.035 5.368 2.562 8.125 5.717 9.997 4.879 2.856 6.653-.591 31.641-3.054 16.758-1.625 25.284-2.363 33.761.394 8.724 2.857 13.061 7.239 16.758 8.274.838.246 1.675.295 2.513.098.296-.049.641-.197.937-.295 4.583-2.019 5.175-9.899 5.717-23.638.838-21.224.788-35.604.887-40.774.296-18.369 3.943-33.339 9.167-49.885-7.59-3.103-11.631-2.413-13.948-.838-6.801 4.58.641 16.744-6.998 29.892-8.083 13.838-23.116 12.065-25.432 22.16-2.859 12.754 18.729 25.657 15.821 29.892-2.859 4.038-20.947-10.539-37.26-4.285-11.484 4.383-11.435 14.971-23.658 20.092-5.126 2.118-10.35 2.512-15.328 1.97h-.295Z",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDBBA",
    d: "m431.303 222.645-6.013-.345s-6.605-5.515-9.611-5.171c-3.056.345-7.491 2.413-8.034 2.856-.542.394 1.676 2.906 3.845 2.66 2.218-.247 7.097.935 7.984 2.856.887 1.92 4.682 3.102 5.274 1.97l8.083 1.625-1.528-6.402v-.049Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M429.479 220.577c-.394 4.924.641 8.322 2.415 10.587 7.984 10.243 35.042 6.008 51.159-7.583 11.878-10.095 18.186-25.854 17.94-39.889-.493-27.429-25.924-54.366-63.776-63.624-5.569 16.744-11.237 33.487-16.807 50.279 23.362.345 37.507 17.925 35.437 30.483-1.528 9.307-12.469 17.777-26.417 19.845h.049v-.098Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.716,
    cy: 211.752,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.429,
    cy: 192.054,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.93,
    cy: 177.281,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.858,
    cy: 295.468,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.644,
    cy: 305.317,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.644,
    cy: 290.544,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.644,
    cy: 211.752,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.859,
    cy: 162.507,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.216,
    cy: 177.281,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.93,
    cy: 201.903,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.787,
    cy: 221.601,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.858,
    cy: 201.903,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.359,
    cy: 285.619,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.287,
    cy: 260.997,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.287,
    cy: 260.997,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.359,
    cy: 251.148,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.287,
    cy: 226.526,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.287,
    cy: 152.658,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.144,
    cy: 310.241,
    fill: "#303464",
    rx: 4.929,
    ry: 4.924
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 113.419,
    x2: 263.573,
    y1: 377.341,
    y2: 34.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1EFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 298.674,
    x2: 319.471,
    y1: 435.53,
    y2: 440.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26284F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 183.591,
    x2: 183.591,
    y1: 109.628,
    y2: 330.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 142.634,
    x2: 104.862,
    y1: -4.57,
    y2: 31.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5861A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 30.212,
    x2: 158.643,
    y1: 3.703,
    y2: 214.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5861A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 98.424,
    x2: -5.921,
    y1: 123.417,
    y2: -86.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 20.01,
    x2: 120.899,
    y1: 82.692,
    y2: 82.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444B8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 86.645,
    x2: 57.564,
    y1: 159.857,
    y2: 1.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 394.88,
    x2: 294.774,
    y1: 310.497,
    y2: 78.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 367.921,
    x2: 387.881,
    y1: 438.927,
    y2: 440.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26284F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 39.429,
    x2: 320.41,
    y1: 211.707,
    y2: 211.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26284F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 303.75,
    x2: 353.555,
    y1: 400.714,
    y2: 269.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 312.77,
    x2: 362.574,
    y1: 404.112,
    y2: 273.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 335.835,
    x2: 401.3,
    y1: 407.608,
    y2: 283.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 379.306,
    x2: 279.101,
    y1: 317.293,
    y2: 85.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 412.18,
    x2: 325.411,
    y1: 260.121,
    y2: 59.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 391.43,
    x2: 364.656,
    y1: 124.057,
    y2: 64.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F4513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68200D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 384.284,
    x2: 357.46,
    y1: 127.307,
    y2: 67.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F4513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68200D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 395.57,
    x2: 311.115,
    y1: 268.098,
    y2: 72.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC9057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 478.666,
    x2: 391.898,
    y1: 231.411,
    y2: 30.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseauFrance);
export default __webpack_public_path__ + "static/media/reseauFrance.c26a34939b503b86f71c6ae497740cfc.svg";
export { ForwardRef as ReactComponent };